import React from "react";
import { useTranslation } from "react-i18next";
import s from "../../FS9-showcaseSelection/ShowcaseSelection.module.less";
import style from "../../FK0-mainCatalog/Categories/Categories.module.less";

const PreviewCategory = ({
  data,
  setIdCategories,
  setIdSubCategories,
  idCategories,
  idSubCategories,
  setPages
}) => {
  const { t } = useTranslation(["ServiceCategories"]);

  return (
    <div>
      <div
        className={s.link}
        style={{ color: "#ea5b0c" }}
        onClick={() => {
          if (idCategories === data.id) {
            setIdCategories(null);
          } else {
            setIdCategories(data.id);
          }
        }}
      >
        {t(`${data.type}.label`)} (
        {data?.subcategories?.map((f) => f.servicesCount).reduce((p, c) => p + c)})
      </div>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          style={{ width: "250px" }}
          className={idCategories === data.id ? `${s.active} ${s.accordion}` : s.accordion}
        >
          {data.subcategories.map((item, index) => (
            <div
              onClick={() => {
                setIdSubCategories(item.id);
                setPages(1);
              }}
              style={
                idSubCategories === item.id
                  ? {
                      margin: "4px 10px 4px 20px",
                      color: "#000"
                    }
                  : { margin: "4px 10px 4px 20px" }
              }
              className={style.link}
            >
              {t(`${data.type}.${item.type}`)} ({item.servicesCount})
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreviewCategory;
